import { constants } from '@yola/subscription-manager-js';

const { B2C_HOSTING_BRONZE, B2C_HOSTING_SILVER, B2C_HOSTING_GOLD } = constants.SubscriptionType;

export default {
  [B2C_HOSTING_GOLD]: {
    P1Y: 'GOLD70P1Y',
    P1M: 'GOLD70P1M',
  },
  [B2C_HOSTING_SILVER]: {
    P1Y: 'SILVER70P1Y',
    P1M: 'SILVER70P1M',
  },
  [B2C_HOSTING_BRONZE]: {
    P1Y: 'BRONZE70P1Y',
    P1M: 'BRONZE70P1M',
  },
};
